var render, staticRenderFns
import script from "./ChartEpssVsCvss.vue?vue&type=script&lang=js&"
export * from "./ChartEpssVsCvss.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5fd0b858')) {
      api.createRecord('5fd0b858', component.options)
    } else {
      api.reload('5fd0b858', component.options)
    }
    
  }
}
component.options.__file = "src/views/dashboard/ChartEpssVsCvss.vue"
export default component.exports